import axios from "axios";
let isSessionExpired = false;

const axiosInstance = axios.create({
  baseURL: 'https://wip.fibrebondindustries.com/api', // ✅ Notice /api
  //baseURL: 'https://localhost:5050/api', // ✅ Notice /api
  withCredentials: true
});

// response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {

    if (error.response && error.response.status === 401 && !isSessionExpired) {

      isSessionExpired = true; // prevent multiple alerts

      sessionStorage.removeItem("auth");
      sessionStorage.removeItem("msalLogin");

      alert("Session expired. Please login again.");

      window.location.href =
        window.location.hostname === "localhost"
          ? "/login"
          : "/auth";
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;